import {api} from '@/services/api/api.service';
import {AxiosResponse} from 'axios';
import MediaCenterService from '@/services/data/media-center.service';
import { IMedia } from '@/services/api/media.service';

export interface IOffersApiService {
  getOffersList: () => Promise<IMedia[]>
}

const getOffersList = (): Promise<IMedia[]> => {
  const mc = MediaCenterService.getMediaCenter();
  return api
    .get(
      '/offers',
      {
        params: { mc },
        data: null
      }
    )
    .then((response: AxiosResponse<IMedia[]>) => response.data)
    .catch((error) => Promise.reject(error));
};

const OffersApiService: IOffersApiService = {
  getOffersList
};

export default OffersApiService;
